import { Typography } from "@mui/material";
import * as Styled from "./Success.styles";

export const SuccessPage = () => {
  return (
    <>
      <Styled.Title variant="h5">Thank you!</Styled.Title>
      <Typography variant="subtitle1" color="text.secondary" sx={{ fontWeight: 500 }}>
        Your order has been successfully placed!
      </Typography>
    </>
  );
};
